/* eslint-disable no-extend-native */
Number.prototype.step = function (step) {
  return Math.round(this / step) * step;
};

Number.prototype.clamp = function (minimum, maximum) {
  return Math.min(Math.max(this, minimum), maximum);
};



// WEBPACK FOOTER //
// ./src/lib/polyfill.js